// Port of api/fuel/app/classes/filter/search/games/rules/query/play_size.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_size',
	field: function() { return 'p.play_players' }
})
